<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="periodo-escolar" titulo="Período Escolar / Coordinación"></app-listar>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside ></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- Opciones y busqueda -->
            <app-tabla-opciones [ctrl]="ctrl"></app-tabla-opciones>

            <span id="exportar_datos" style="overflow-y:auto; overflow-x: hidden; display:block; height: 79vh;">

                <!--Tabla -->
                <table class="table is-striped is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando ">
                    <thead>
                        <tr>
                            <th><abbr>ID</abbr></th>
                            <th>Nombre</th>
                            <th>Ciclo escolar</th>
                            <th>Modalidad</th>
                            <th>Tipo</th>
                            <th>Grupos</th>
                            <th>Vigente</th>
                            <th>Fecha inicio</th>
                            <th>Fecha fin</th>

                            <th width="1%">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ctrl.dato; let i=index">
                            <th style="vertical-align: middle;">{{ i + 1 }}</th>
                            <td style="vertical-align: middle;">
                              <span *ngIf="item.periodo_escolar_anterior==NULL  && item.periodos_siguientes==NULL" title="Periodo origen" class="icon-flag fa-2x is-success"></span>
                              <span *ngIf="item.periodo_escolar_anterior==NULL && item.periodos_siguientes!=NULL" title="Periodo origen. Periodo siguiente: {{item.periodos_siguientes?.nombre}}" class="icon-flag fa-2x is-success"></span>
                              <span *ngIf="item.continuado==1 && item.periodo_escolar_anterior!=NULL" title="Periodo siguiente: {{item.periodos_siguientes?.nombre}}" class="fa fa-lock fa-2x is-success"></span>
                              <span *ngIf="item.continuado==0 && item.periodo_escolar_anterior!=NULL" title="Periodo anterior: {{item.periodos_anteriores?.nombre}}" class="icon-unlock fa-2x is-success"></span>
                              {{ item.nombre }}
                            </td>
                            <td style="vertical-align: middle;">{{ item.ciclos_escolares?.fecha_inicio | slice:0:4 }} - {{ item.ciclos_escolares?.fecha_fin | slice:0:4 }} </td>
                            <td style="vertical-align: middle;">{{ item.modalidades?.nombre }} </td>
                            <td style="vertical-align: middle;">{{ item.tipos_periodos?.nombre }} </td>
                            <td style="vertical-align: middle;" *ngIf="item.grupos!=null">
                                <div class="level">
                                    <button class="navbar-item"
                                        (click)="ver_grupo($event,item,'lista');">
                                        <span class="icon fa-2x  has-text-success">
                                            {{item.grupos.length}}
                                        </span>
                                        <!-- <span class="tooltiptext">Alumnos: {{item.grupos_alumnos.length}}</span> -->
                                    </button>
                                </div>
                            </td>
                            <td style="vertical-align: middle;"> <span *ngIf="item.vigente==1"> <i class="fa fa-circle fa-2x has-text-success"></i>  </span> <span *ngIf="item.vigente==0"> <i class="fa fa-circle fa-2x has-text-danger"></i> </span></td>
                            <td style="vertical-align: middle;">{{ item.fecha_inicio }} </td>
                            <td style="vertical-align: middle;">{{ item.fecha_fin }} </td>
                            <td style="vertical-align: middle;" class="has-text-centered">
                                <!-- acciones -->
                                <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                            </td>

                        </tr>
                        <tr *ngIf="ctrl.dato.length == 0">
                            <td colspan="9" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>

                <!--Lista -->
                <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando">
                    <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;" [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
                        <article class="media">
                            <div class="media-left">
                            <figure class="image is-64x64">
                                <img src="./assets/128x128.png" alt="Image">
                            </figure>
                            </div>
                            <div class="media-content">
                                <div class="content">
                                    <p>
                                        <strong class="tag is-medium">
                                            {{item.id}}
                                            <small>Nombre: {{ item.nombre }}</small>
                                        </strong>

                                        <strong class="tag is-medium">
                                          Ciclo escolar: {{ item.ciclos_escolares?.fecha_inicio | slice:0:4 }} - {{ item.ciclos_escolares?.fecha_fin | slice:0:4 }}
                                        </strong>

                                        <strong class="tag is-medium">
                                            Modalidad: {{ item.modalidades?.nombre }}
                                        </strong>

                                        <strong class="tag is-medium">
                                            Tipo: {{ item.tipos_periodos?.nombre }}
                                        </strong>

                                        <strong class="tag is-medium">
                                          <span *ngIf="item.vigente==1"> <i class="fa fa-circle has-text-success"></i> </span>
                                          <span *ngIf="item.vigente==0"> <i class="fa fa-circle has-text-danger"></i> </span>
                                        </strong>

                                        <strong class="tag is-medium">
                                            Fecha inicio: {{ item.fecha_inicio }}
                                        </strong>

                                        <strong class="tag is-medium">
                                            Fecha fin: {{ item.fecha_fin }}
                                        </strong>
                                    </p>
                                </div>
                                <nav class="level is-mobile" style="float:right">
                                    <div class="level-left">

                                        <!-- acciones -->
                                        <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                                    </div>
                                </nav>
                            </div>
                        </article>
                    </div>
                </span>
            </span>
            <!-- Paginación para la lista  -->
            <app-paginacion [ctrl]="ctrl"></app-paginacion>

        </div>
    </div>
</div>

<div id="detalle-grupo" class="modal">
    <div class="modal-background"></div>
    <div  *ngIf="datos_periodo!=''" class="modal-card" style="width:95%; height: auto;">
        <header class="modal-card-head">
            <p class="modal-card-title"><strong>Detalles</strong></p>
            <button class="delete" aria-label="close" (click)="cerrar_modal()"></button>
        </header>
        <section class="modal-card-body">
            <!-- Content ... -->
            <nav class="level is-mobile">
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Grupos</p>
                        <p class="title"> {{datos_periodo.grupos.length}} </p>
                    </div>
                </div>
                <!-- <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Nivel</p>
                        <p class="title"></p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Carrera</p>
                        <p class="title">{{detalles.carreras_planes.carreras.sigla}}</p>
                    </div>
                </div>-->
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Período escolar</p>
                        <p class="title">{{datos_periodo.nombre}}</p>
                    </div>
                </div> 
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Tipo período</p>
                        <p class="title">{{datos_periodo.tipos_periodos.nombre}}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Modalidad</p>
                        <p class="title">{{datos_periodo.modalidades.nombre}}</p>
                    </div>
                </div> 
            </nav>

            <div class="content">
             
                <table class="table is-striped" >
                    <thead>
                        <tr style="text-align: center;">
                            <th>CLAVE</th>
                            <th>NOMBRE</th>
                            <th>NIVEL</th>
                            <th>TOTAL HOMBRES</th>
                            <th>TOTAL MUJERES</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of datos_periodo.grupos">
                            <td style="vertical-align: middle; text-align: center;"> {{item.clave}} </td>
                            <td style="vertical-align: middle; text-align: center;"> {{item.carreras_planes.carreras.nombre}} </td>
                            <td style="vertical-align: middle; text-align: center;"> {{item.nivel}} </td>
                            <td style="vertical-align: middle; text-align: center;" *ngIf="item.total_hombres_inicio != null"> {{item.total_hombres_inicio}} </td>
                            <td style="vertical-align: middle; text-align: center;" *ngIf="item.total_hombres_inicio == null"> 0 </td>
                            <td style="vertical-align: middle; text-align: center;" *ngIf="item.total_mujeres_inicio != null"> {{item.total_mujeres_inicio}} </td>
                            <td style="vertical-align: middle; text-align: center;" *ngIf="item.total_mujeres_inicio == null"> 0 </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </section>
        <footer class="modal-card-foot">
            <button class="button" (click)="cerrar_modal()">Ok!</button>
            <!-- <button class="button is-success  is-pulled-right" (click)="imprimirLista(true)"> <i
                    class="icon-document"></i> Imprimir lista asistencia</button>
            <button class="button is-link  is-pulled-right" (click)="imprimirLista(false)"> <i
                    class="icon-document"></i> Imprimir lista</button>
            <button class="button is-link  is-pulled-right" (click)="imprimirLista(2)"> <i class="icon-document"></i>
                Imprimir</button>
            <div class="b-checkbox is-info">
                <input type="checkbox" id="baja" name="baja" [(ngModel)]="baja"
                    [ngModelOptions]="{standalone: true}">
                <label for="baja">
                    Imprimir alumnos BAN
                </label>
            </div> -->
        </footer>
    </div>
</div>

<div class="modal" id="no-grupos">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title"><i class="fa fa-warning"></i> Mensaje</p>
            <button class="delete" (click)="cerrar_modal_no()"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>Este periodo no cuenta con grupos por el momento</h1>
                <!-- <p>Ya no se podra recuperar la información</p> -->
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button" (click)="cerrar_modal_no()">Ok</a>
        </footer>
    </div>
</div>
